module.exports = __webpack_public_path__ + "static/img/14000033.ae3d57d0.png";